<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2pn" id="part01"><a id="page_11"><strong>PART ONE</strong><br/><img alt="Image" src="images/common1.jpg"/></a></h2><a id="page_11">
<h2 class="h2pt">crafting the <strong>SOUL</strong></h2>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?ffdfe88a